module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"screen":"Screen","viewCount":"View count","visits":"Visits","uniqueUsers":"Users"},"ja":{"screen":"スクリーン","viewCount":"ビュー数","visits":"訪問数","uniqueUsers":"ユーザ数"},"zh-hant":{"screen":"手機頁面","viewCount":"查看次數","visits":"訪問數","uniqueUsers":"使用者數"},"zh-hans":{"screen":"手机页面","viewCount":"查看次数","visits":"访问量","uniqueUsers":"用户数"}}')
  delete Component.options._Ctor
}
